var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 59,
    viewBox: "0 0 54 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8243 0.89312C1.16939 1.59699 0.792969 2.68034 0.792969 4.08809V54.161C0.792969 55.5687 1.16939 56.6521 1.84878 57.3315L2.02628 57.4814L30.0832 29.4244V28.794L2.00179 0.743164L1.8243 0.89312Z",
    fill: "url(#paint0_linear_939_2145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.417 38.8144L30.0586 29.4529V28.798L39.4201 19.4365L39.6221 19.562L50.6943 25.854C53.8648 27.6412 53.8648 30.5853 50.6943 32.397L39.6221 38.689C39.619 38.689 39.417 38.8144 39.417 38.8144Z",
    fill: "url(#paint1_linear_939_2145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6191 38.6895L30.0587 29.126L1.82422 57.3604C2.85555 58.4683 4.59074 58.5938 6.53098 57.5104L39.6191 38.6895Z",
    fill: "url(#paint2_linear_939_2145)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6191 19.564L6.53098 0.767505C4.5938 -0.340329 2.85555 -0.190374 1.82422 0.91746L30.0556 29.1244L39.6191 19.564Z",
    fill: "url(#paint3_linear_939_2145)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.418 38.4873L6.55637 57.1583C4.72019 58.2141 3.08292 58.1407 2.02711 57.1828L1.84961 57.3603L2.02711 57.5102C3.08292 58.465 4.72019 58.5416 6.55637 57.4857L39.6445 38.6893L39.418 38.4873Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6893 32.07L39.3906 38.4875L39.5926 38.6895L50.6648 32.3975C52.2501 31.4916 53.0304 30.3103 53.0304 29.126C52.9295 30.2093 52.1246 31.2407 50.6893 32.07Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53106 1.09534L50.6914 26.1838C52.1267 26.9887 52.9316 28.0445 53.057 29.1278C53.057 27.9465 52.2766 26.7622 50.6914 25.8564L6.53106 0.767886C3.36057 -1.04382 0.792969 0.464915 0.792969 4.08833V4.41578C0.792969 0.792368 3.36057 -0.691885 6.53106 1.09534Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_939_2145",
    x1: 27.5639,
    y1: 3.54986,
    x2: -17.3786,
    y2: 15.5248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_939_2145",
    x1: 54.82,
    y1: 29.1269,
    x2: 0.0222407,
    y2: 29.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_939_2145",
    x1: 34.4204,
    y1: 34.3286,
    x2: -1.65951,
    y2: 95.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_939_2145",
    x1: -5.28309,
    y1: -15.7637,
    x2: 10.8133,
    y2: 11.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google-play-icon.dedb3ca7be67127d799f84332c12f2be.svg";
export { ForwardRef as ReactComponent };